import React from "react";
import Quantity from "./Quantity";
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom"
import CustomImage from "./CustomImage";
import PriceDisplay from "./PriceDisplay";
import PriceDisplayWithCustomOption from "./PriceDisplayWithCustomOption";
import { formatCustomOptionDisplay } from "./customOptionUtils";
import { PET_ACCESSORIES, getCustomDataExtrasTotalPrice, getPetCount, getExtraPetsPrice, getAccessoryDescription, getAccessoryLabel } from "./petAccessoryUtils";
import korpa from '../images/korpa.png';
import { localized, localizedCat, useLanguage } from '../i18n/translations';
import { OFFERED_LANGUAGES } from '../i18n/languageAccess';

export default function Header({ cartItems, ChangeQty, productsData, totalSubtotal, RemoveItemFromCart, currency, country, ChangeCountry, translate, language, changeLanguage, isCartOpen, setIsCartOpen, categories }) {
  // Only visitors who came in on a ?lang=1 link ever see the language picker.
  const { unlocked: showLanguagePicker } = useLanguage();
  const [isMenuOpen, setMenuOpen] = React.useState(false);
  const [isShopDropdownOpen, setShopDropdownOpen] = React.useState(false);
  const [isDesktop, setIsDesktop] = React.useState(false);

  React.useEffect(() => {
    const checkDesktop = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);


  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };







  const ItemsInCart = productsData.map(product => (
    cartItems.map(item => {
      if (item.id === product.id) {

        return (
          <div className="p-4 text-black items-start border-b border-gray-200" key={item.cartKey || product.id}>
            <div className="flex">
              <div className="w-20 flex-shrink-0">
                <CustomImage src={(item.setData?.image_index !== null && item.setData?.image_index !== undefined && product.listingImages?.[item.setData.image_index]) ? product.listingImages[item.setData.image_index] : product.imageUrl} alt={product.imageAlt} className="w-20" />
              </div>
              <div className="ml-2 flex flex-col flex-1 min-w-0">
                <div className="flex flex-col">
                  <div className="flex">
                    <span className="text-sm w-full">{localized(product, 'name', language)}{item.setData?.label && (
                      <span className="ml-1 text-xs text-gray-500">({item.setData.label})</span>
                    )}{item.customOption && (
                      <span className="ml-1 text-xs text-gray-900">({formatCustomOptionDisplay(product?.custom_options, item.customOption, language)})</span>
                    )}</span>
                    <button onClick={() => RemoveItemFromCart(item.cartKey || product.id)}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>

                  </div>
                  <PriceDisplayWithCustomOption product={product} currency={currency} customOption={item.customOption} selectedSet={item.setData} accessoriesModifier={getCustomDataExtrasTotalPrice(item.customData, currency)} className="text-sm" />
                </div>
                <div>
                  {(() => {
                    const isSetUnavailable = item.setData
                      ? !(item.setData.items || []).every(setItem => {
                          const p = productsData.find(pd => pd.id === setItem.product_id);
                          return p && p.available && p.is_in_stock;
                        })
                      : false;
                    if (isSetUnavailable) return <span className="text-red-600 text-xs">{translate("Set is currently out of stock")}</span>;
                    if (!product.available || !product.is_in_stock) return <span className="text-red-600">{translate("Product is currently out of stock")}</span>;
                    return <Quantity id={item.cartKey || item.id} oldQty={item.qty} onHandle={ChangeQty} />;
                  })()}
                </div>
                {item.customData?.optionInputText && (
                  <div className="mt-1 text-xs text-gray-600">
                    {translate("Text")}: <span className="font-medium">{item.customData.optionInputText}</span>
                  </div>
                )}
                {item.customData && (item.customData.description || item.customData.color || item.customData.date || item.customData.secondPet || (item.customData.images && item.customData.images.length > 0) || (item.customData.accessories && item.customData.accessories.length > 0) || (item.customData.customAccessories && item.customData.customAccessories.length > 0)) && (
                  <div className="mt-2 pt-2 border-t border-gray-200 max-w-full">
                    <div className="text-xs text-gray-600 space-y-1">
                      {item.customData.color && (
                        <div>{translate("Color")}: <span className="font-medium">{item.customData.color}</span></div>
                      )}
                      {item.customData.secondPet && (
                        <div>{translate("Number of pets")}: <span className="font-medium">{getPetCount(item.customData)} (+{getExtraPetsPrice(item.customData, currency).toFixed(2)} {currency})</span></div>
                      )}
                      {item.customData.accessories && item.customData.accessories.length > 0 && (
                        <div>
                          <span className="font-medium">{translate("Accessories")}:</span>
                          <div className="flex flex-wrap gap-1 mt-1">
                            {item.customData.accessories.map(id => {
                              const acc = PET_ACCESSORIES.find(a => a.id === id);
                              return acc ? (
                                <div key={id} className="relative group">
                                  <img src={acc.image} alt={getAccessoryLabel(acc, language)} title={getAccessoryDescription(acc, item.customData?.priceProfile, language)} className="w-8 h-8 object-contain rounded border border-gray-200 bg-white p-0.5" />
                                  <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-white border border-gray-200 rounded px-1.5 py-0.5 text-xs text-gray-700 whitespace-nowrap shadow z-50">
                                    {getAccessoryLabel(acc, language)}
                                  </span>
                                </div>
                              ) : null;
                            })}
                          </div>
                        </div>
                      )}
                      {item.customData.customAccessories && item.customData.customAccessories.length > 0 && (
                        <div>
                          <span className="font-medium">{translate("Custom accessories")}:</span>
                          <ul className="mt-0.5 ml-3 list-disc">
                            {item.customData.customAccessories.map((text, i) => (
                              <li key={i}>{text}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {item.customData.description && (
                        <div className="break-words max-w-full overflow-hidden">
                          <span className="font-medium">{translate("Description")}:</span>
                          <p className="mt-1 text-gray-700 leading-relaxed line-clamp-3">{item.customData.description}</p>
                        </div>
                      )}
                      {item.customData.date && (
                        <div>{translate("Date")}: {item.customData.date}</div>
                      )}
                      {item.customData.images && item.customData.images.length > 0 && (
                        <div className="mt-1">
                          <div className="text-xs font-medium text-gray-500 mb-1">{translate("Reference images")}:</div>
                          <div className="flex flex-wrap gap-1">
                            {item.customData.images.slice(0, 3).map((image, idx) => {
                              const imageUrl = image instanceof File ? URL.createObjectURL(image) : image;
                              return (
                                <img 
                                  key={idx} 
                                  src={imageUrl} 
                                  alt="Reference" 
                                  className="h-8 w-8 object-cover rounded border border-gray-300"
                                />
                              );
                            })}
                            {item.customData.images.length > 3 && (
                              <span className="text-xs text-gray-500">+{item.customData.images.length - 3}</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      }
    })
  ));




  return (
    <div>
      {/* Free Shipping Banner */}
      <div className="bg-brownSkin/60 text-white py-3 px-4 text-center z-[21] relative">
        <span className="text-sm">
          {country === "RS" && `🚚 ${translate("Free shipping on all orders over 9000 RSD within Serbia")}`}
          {country === "BA" && `🚚 ${translate("Free shipping on all orders over 150 KM within Bosnia and Herzegovina")}`}
          {country === "HR" && `🚚 ${translate("Free shipping on all orders over 80 EUR within Croatia")}`}
          {country === "CG" && `🚚 ${translate("Free shipping on all orders over 80 EUR within Montenegro")}`}
        </span>
      </div>

      <header className="header bg-bgSkin">

        <div className="flex flex-row justify-around  items-center p-4 sm:px-16">



          {/* links */}
          <div className=" w-full  justify-start flex z-20">
            <input
              className="menu-btn"
              type="checkbox"
              id="menu-btn"
              checked={isMenuOpen}
              onChange={toggleMenu}
            />
            <label className="menu-icon z-[999]" htmlFor="menu-btn">
              <span className="navicon"></span>
            </label>
            <ul className={`menu absolute md:relative  bg-bgSkin left-0 top-0 w-full ${isMenuOpen ? 'open' : ''}`}>
            <li className="py-6 mt-[200px] md:mt-0">
            
              </li>
              <li 
                className="py-6 relative shop-dropdown-parent"
                onMouseEnter={() => {
                  if (isDesktop) {
                    setShopDropdownOpen(true);
                  }
                }}
                onMouseLeave={() => {
                  if (isDesktop) {
                    setShopDropdownOpen(false);
                  }
                }}
              >
                <span 
                  className="cursor-pointer flex items-center text-black hover:text-brownSkin transition-colors duration-200 px-5"
                  onClick={() => {
                    if (!isDesktop) {
                      setShopDropdownOpen(!isShopDropdownOpen);
                    }
                  }}
                >
                  {translate("Shop")}
                  <svg className={`w-4 h-4 ml-1 transition-transform duration-300 ${isShopDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
                <ul 
                  className={`shop-dropdown md:absolute md:top-full md:left-0 md:pt-3 md:pb-3 md:bg-bgSkin md:shadow-xl md:rounded-lg md:min-w-[240px] md:z-[10000] md:border md:border-brownSkin/20 md:whitespace-nowrap transition-all duration-300 ease-out ${
                    isShopDropdownOpen 
                      ? 'md:opacity-100 md:translate-y-0 md:pointer-events-auto' 
                      : 'md:opacity-0 md:-translate-y-2 md:pointer-events-none'
                  } ${
                    !isDesktop 
                      ? (isShopDropdownOpen ? 'max-h-[9999px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden')
                      : ''
                  }`}
                  style={!isDesktop ? { 
                    paddingLeft: '20px', 
                    marginLeft: '0', 
                    position: 'relative', 
                    width: '100%',
                    textAlign: 'left'
                  } : {}}
                >
                  {categories && categories.length > 0 && categories
                    .filter(category => category.is_main_collection === true || category.is_main_collection === 1)
                    .map(category => (
                    <li key={category.id} className="w-full">
                      <Link
                        to={`/kolekcije/${category.path}`}
                        onClick={() => {
                          setMenuOpen(false);
                          setShopDropdownOpen(false);
                        }}
                        className="block w-full !px-8 !py-8 text-black hover:bg-darkerSkin hover:text-brownSkin transition-all duration-200 font-medium border-b border-brownSkin/10"
                      >
                        {localizedCat(category, 'title', language)}
                      </Link>
                    </li>
                  ))}
                  {categories && categories.length > 0 && categories
                    .filter(category => (category.is_collection === true || category.is_collection === 1) && !(category.is_main_collection === true || category.is_main_collection === 1))
                    .map(category => (
                    <li key={category.id} className="w-full">
                      <Link
                        to={`/kolekcije/${category.path}`}
                        onClick={() => {
                          setMenuOpen(false);
                          setShopDropdownOpen(false);
                        }}
                        className="block w-full !px-8 !py-8 text-black hover:bg-darkerSkin hover:text-brownSkin transition-all duration-200 font-medium border-b border-brownSkin/10"
                      >
                        {localizedCat(category, 'title', language)}
                      </Link>
                    </li>
                  ))}
                  {categories && categories.length > 0 && categories
                    .filter(category => !(category.is_collection === true || category.is_collection === 1))
                    .map(category => (
                    <li key={category.id} className="w-full">
                      <Link
                        to={`/kategorija/${category.path}`}
                        onClick={() => {
                          setMenuOpen(false);
                          setShopDropdownOpen(false);
                        }}
                        className="block w-full !px-8 !py-8 text-black hover:bg-darkerSkin hover:text-brownSkin transition-all duration-200 font-medium border-b border-brownSkin/10 last:border-b-0"
                      >
                        {localizedCat(category, 'title', language)}
                      </Link>
                    </li>
                  ))}
                  <li className="w-full">
                    <Link
                      to="/proizvod/8/keramicki-andjeo-cuvar"
                      onClick={() => {
                        setMenuOpen(false);
                        setShopDropdownOpen(false);
                      }}
                      className="block w-full !px-8 !py-8 text-black hover:bg-darkerSkin hover:text-brownSkin transition-all duration-200 font-medium border-b border-brownSkin/10"
                    >
                      {translate("Ceramic angel")}
                    </Link>
                  </li>
                  <li className="w-full">
                    <Link 
                      to="/kolekcije/sve"
                      onClick={() => {
                        setMenuOpen(false);
                        setShopDropdownOpen(false);
                      }}
                      className="block w-full !px-8 !py-8 text-black hover:bg-darkerSkin hover:text-brownSkin transition-all duration-200 font-medium"
                    >
                      {translate("View all")}
                    </Link>
                  </li>
          
                </ul>
              </li>
              <li className="py-6"><NavLink onClick={() => setMenuOpen(false)} to="/radionice-keramike">{translate("Workshops")}</NavLink></li>
              {/* Poslovni pokloni — privremeno sklonjeno sa sajta. Vrati ovaj red da se opet prikaže.
              <li className="py-6"><NavLink onClick={() => setMenuOpen(false)} to="/korporativni-pokloni">{translate("Business Gifts")}</NavLink></li>
              */}
            </ul>
          </div>

          {/*logo */}
          <div className=" min-w-[150px] flex  justify-center  z-[998]">
            <Link to="/" className="logo text-center">
              <img src="/images/logo.png" className="w-[130px] " alt="Logo" />
            </Link>
          </div>


          {/* cart icon */}
          <div className=" flex w-full   justify-end ">
            <div className={`w-24 items-center justify-around flexl hidden ${isMenuOpen ? "hidden" : ""}`}>
              <button onClick={() => ChangeCountry("BA")}><img className={`w-6 h-6 rounded-[100px] ${country === "BA" ? " border-[3px] border-black" : ""}`} src="/images/countries/BA.png" /></button>
              <button onClick={() => ChangeCountry("RS")}><img className={`w-6 h-6 rounded-[100px] ${country === "RS" ? " border-[3px] border-black" : ""}`} src="/images/countries/RS.png" /></button>
              <button onClick={() => ChangeCountry("US")}><img className={`w-6 h-6 rounded-[100px] ${country === "US" ? " border-[3px] border-black" : ""}`} src="/images/countries/US.png" /></button>
            </div>


              {/* Language picker — independent of country/currency. */}
              {showLanguagePicker && (
              <div className="flex items-center mr-2">
                {OFFERED_LANGUAGES.map((lng) => (
                  <button
                    key={lng.code}
                    onClick={() => changeLanguage(lng.code)}
                    title={lng.name}
                    aria-label={lng.name}
                    className={`text-sm leading-none px-1 transition-opacity ${language === lng.code ? 'opacity-100 font-semibold underline' : 'opacity-50 hover:opacity-80'}`}
                  >
                    {lng.label}
                  </button>
                ))}
              </div>
              )}



            <button onClick={toggleCart} className="">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
            </button>
            <button onClick={toggleCart}>
              <span className="text-sm">({cartItems.length})</span>
            </button>
          </div>
        </div>

      </header>



      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[400px] flex bg-white z-[999]  text-white  transform ${isCartOpen ? '' : 'translate-x-full'
          } transition-transform duration-500 ease-in-out`}
      >
        <div className="w-full">
          {/* Cart content goes here */}
          <div className="w-full h-full flex flex-col">

            <div className="flex items-center justify-between w-full bg-white border-b border-gray-200 p-4 h-16 sticky top-0">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="black" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
              <span className="text-gray-900 text-lg font-semibold">{translate("Cart")}</span>
              <button onClick={() => setIsCartOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="black" className="w-6 h-6">
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="flex-1 overflow-y-auto custom-scrollbar-style">
              {cartItems.length === 0 ? <div className=" p-4 text-black"><span>{translate("Your cart is empty.")}</span></div> : ItemsInCart}
            </div>

          

            <div className="w-full  border-t pb-4 border-gray-200  flex-shrink-0 bg-bgSkin">
              <div className="p-4">
                <div className="w-full items-center justify-center flex">
                  <img src={korpa} className="h-20 w-auto sm:h-24 object-contain" />
                </div>
                <div className="flex items-center justify-between text-black mt-2">
                  <span className="text-sm">{translate("Subtotal")}:</span>
                  <span className="text-sm ">{totalSubtotal} {currency}</span>
                </div>
                <div className="text-xs text-gray-600 mt-1">{translate("Shipping is calculated at checkout")}</div>
              </div>
              <div className="px-4 w-full items-center justify-center flex">
                <Link onClick={() => setIsCartOpen(false)} to="/cart" className="w-full px-6 py-3 rounded-full font-medium transition-all duration-300 bg-darkerSkin text-white hover:bg-[#d4a76a] hover:shadow-lg text-center">{translate("View Cart")}</Link>
              </div>
            </div>

          </div>
        </div>


      </div>


      {/* Overlay */}
      {isCartOpen && (
        <div
          className="fixed top-0 left-0 w-full z-[998] h-full bg-black opacity-30 transition-opacity duration-300"
          onClick={() => setIsCartOpen(false)} // Close the cart when clicking on the overlay
        />
      )}





    </div>
  )
}